import { getFileExtension } from "./archiveDocumentUtils";

const HTML_EXTENSIONS = new Set([".html"]);

const HTML_MIME_TYPES = new Set(["text/html"]);

export const isHtmlDocument = (
  fileName?: string | null,
  mimeType?: string | null
): boolean => {
  const extension = getFileExtension(fileName);
  const mime = (mimeType ?? "").toLowerCase().trim();

  return HTML_EXTENSIONS.has(extension) || HTML_MIME_TYPES.has(mime);
};
